module.exports = __webpack_public_path__ + "static/gallery-10-5fcc8a7a5b35489dff2c4de76eef7e80.jpg";